<template>

    <div class="has-text-centered">
        <div class="app-block p-md">
            <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
        </div>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                checkout: '',
                errorMsg: ''
            }
        },
        props: {
            candidate: { type: Object }
        },
        created () {
            this.errorMsg = this.$t('candidate.fees.bank_cb.button')
        }
    }
</script>